module.exports = __webpack_public_path__ + "static/media/sliderimg2.20a138cd.png";